export default {
  // listTitleTable: {
  //   Order: 'Order',
  //   Ticker: 'Ticker',
  //   TradingTime: 'TradingTime',
  //   OrderPrice: 'OrderPrice',
  //   MatchedPrice: 'MatchedPrice',
  //   Volume: 'Volume',
  //   OrderStatus: 'OrderStatus',
  //   OrderAction: 'OrderAction',
  // },
  listTiteComponent: {
    Account: 'Account',
    TotalPrice: 'Total Money',
    TotalDebt: 'Total Debt',
    Order: 'Order',
    OrderBook: 'Order book',
    Volume: 'Volume',
    Ceiling: 'Ceiling',
    Reference: 'Reference',
    Floor: 'Floor',
    Max: 'Max',
    MatchedPrice: 'Matched Price',
    Price: 'Price',
    StockValue: 'Stock value',
    NetAssetValue: 'Net asset value',
    PurchasingPower: 'Purchasing Power',
    TradeQuantity: 'Trade Quantity',
    MaxVolume: 'Max Volume',
  },
  listTitleTable: {
    symbol: 'ticker',
    price: 'price',
    side: 'side',
    Status: 'status',
    quantity: 'quantity',
    avgPrice: 'avgPrice',
    cancelVolume: 'cancel Volume',
    createdDate: 'created Date',
  },
  listStatusType: {
    GETALL: 'All',
    PENDINGNEW: 'Pending New',
    NEW: 'New',
    // SENT: 'Sent',
    PARTIALLYFILLED: 'Partially Filled',
    FILLED: 'Filled',
    REJECTED: 'Rejected',
    EXPIRED: 'Expired',
    PENDINGCANCEL: 'Pending Cancel',
    CANCELLED: 'Cancelled',
  },
  listTextOrderPopup: {
    TextPARTNERS: "FIINTRADE'S PARTNERS",
    TextOtherPARTNERS: 'OTHER PARTNERS',
    TextConditions: 'TERM AND CONDITIONS',
    TextAgreed:
      'I have read and agreed with the terms and conditions from FiinTrade.',
    SaveOTP: 'Save OTP authentication',
    ResendOTP: 'Resend OTP',
    ResendOTPIn: 'Resend OTP in',
  },
  listActionOrderPopup: {
    Login: 'Login',
    Agree: 'OK',
  },
  messageErrors: {
    PriceLessFloor: 'Order price is lower than the floor price',
    PriceHigherCelling: 'Order price is higher than the celling price',
    PriceInvalid: 'Invalid order price',
    VolumeHigherQmax: 'Order volume is higher than max Volume',
    VolumeInvalid: 'Invalid order volume',
    Please: 'Please try again!',
    Error: 'Error',
  },
  titileTooltip: {
    Money: 'Money:',
    TermDeposit: 'Term Deposit:',
    CashDividendReceiving: 'Cash Dividend Receiving:',
    DepositInterest: 'Deposit Interest:',
    ReceivingAmount: 'Receiving Amount:',
    SecureAmount: 'Secure Amount:',
    MarginDebt: 'Margin Debt:',
    WithdrawableCash: 'Withdrawable Cash:',
    Copy: 'Copy order',
    Cancle: 'Cancel order',
  },
  orderType: {
    LO: 'Actively input the trading price',
    ATO: 'Trading at the opening price',
    ATC: 'Trading at the closing price',
    MP: 'Trade at market price, unmatched part becomes LO',
    PLO: 'Trading at closing price after ATC',
    MTL: 'Trading at any prices, the unmatched volume becomes LO',
    MOK:
      'Trading at any prices and the order must be filled entirely or cancelled',
    MAK:
      'Trading at any prices and the order can be filled partially or cancelled',
  },
};
